module.exports = __webpack_public_path__ + "static/media/DoOne_wht.7cc1d3c0.png";